<script>
import gmap from '@/library/google-map'

export default {
  data: () => ({
    map: null
  }),
  props: {
    streetViewControl: { type: Boolean, default: false },
    mapTypeControl: { type: Boolean, default: false },
    fullscreenControl: { type: Boolean, default: false },
    disableDefaultUI: { type: Boolean, default: false },
    zoomControlPosition: { type: Number, default: 8 },
    lat: { type: Number, default: 56.0769037 },
    lng: { type: Number, default: 10.1620189 },
    zoom: { type: Number, default: 7 }
  },
  watch: {
    lat: 'setLatLng',
    lng: 'setLatLng',
    zoom: 'setZoom'
  },
  provide () {
    const provide = {}

    Object.defineProperty(provide, '$map', {
      enumerable: true,
      get: () => this.map
    })

    return provide
  },
  async beforeCreate () {
    try {
      this.$options.google = await gmap()
      this.init()
    } catch (err) {
      throw err
    }
  },
  methods: {
    init () {
      this.map = new this.$options.google.maps.Map(this.$el, {
        center: {lat: this.lat, lng: this.lng},
        zoom: this.zoom,
        streetViewControl: this.streetViewControl,
        mapTypeControl: this.mapTypeControl,
        fullscreenControl: this.fullscreenControl,
        disableDefaultUI: this.disableDefaultUI,
        scrollwheel: false,
        zoomControlOptions: {
          position: this.zoomControlPosition
        }
      })
    },
    setLatLng () {
      if (this.map) {
        this.map.setCenter({lat: this.lat, lng: this.lng})
      }
    },
    setZoom () {
      if (this.map) {
        this.map.setZoom(this.zoom)
      }
    }
  },
  render (h) {
    const slots = this.map ? this.$slots.default : []
    return h('DIV', { class: ['map-' + Date.now(), 'gmap'] }, slots)
  }
}
</script>

<style lang="scss" scoped>
  .gmap {
    width: 100%;
    height: 100%;
    min-height: 460px;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/index.vue